import store from "@/store"

export default (to, from, next) => {
  if (to.query.cf_source === "true" || to.query.contentful === "true") {
    store.commit("content/SET_SOURCE_MODE", true)
    next()
  } else {
    next()
  }
}
